export default {
  USERS: 'users',
  USER_DEPARTMENTS: 'user-departments',
  USER_SUBSCRIPTIONS: 'user-subscriptions',
  NOTIFICATIONS: 'notifications',

  CONFIGS: 'configs',
  FLOORS: 'floors',
  BUILDINGS: 'buildings',
  EMPLOYEES: 'employees',
  EMPLOYEE_IMPORTS: 'employee-imports',
  POSITIONS: 'employee-positions',
  DEPARTMENTS: 'departments',
  POINTS: 'points',
  POINTS_ENTITY_SEARCH: 'points/entity-search',
  POINT_ICONS: 'point-icons',
  ROOMS: 'rooms',
  PRINTERS: 'printers',
  PCS: 'pcs',
  FILES: 'files',
  DESKS: 'desks',
  DESK_EVENTS: 'desk-events',
  DESK_EVENT_SETS: 'desk-event-sets',

  AUTH_ITEMS: 'auth-items',
  AUTH_PERMISSIONS: 'auth-permissions',
  SCIM_SETTINGS: 'scim/settings',
  SAML_SETTINGS: 'saml/settings',
}
